import { render, staticRenderFns } from "./PaymentUpgrade.vue?vue&type=template&id=5f284cfe&scoped=true&"
import script from "./PaymentUpgrade.vue?vue&type=script&lang=js&"
export * from "./PaymentUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./PaymentUpgrade.vue?vue&type=style&index=0&id=5f284cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f284cfe",
  null
  
)

export default component.exports